<template>
  <el-container class="layout__wrap">
    <el-header class="header__wrap" height="60px">
      <div class="logo__wrap">
        <img class="logo" src="@/assets/images/logobaise.png" alt="" />
        <!-- <div class="J_menutoggle" @click="toggleColl">
          <el-tooltip
            effect="dark"
            :content="isCollapse ? `展开` : `收起`"
            placement="bottom">
            <i class="el-icon-menu" color="#fff"></i>
          </el-tooltip>
        </div> -->
        <!-- <span class="logoText">校园聘后台管理系统</span> -->
      </div>
      <div class="avatar__wrap">
        <div class="avatar__wrap-left">
          <img src="" alt="" />
          <span class="marginright40" style="font-weight: 800">{{
            info && info.name
          }}</span>
          <span class="hasBorder marginright10">{{ info && info.nickname }}</span>
          <span class="hasBorder">{{ account }}</span>
        </div>
        <div class="avatar__wrap-right">
          <span
            class="marginright10"
            @click="viewBalance"
            style="cursor: pointer"
            >人才币:</span
          >
          <span style="margin-right: 6px; color: #ff4141">{{
            info && info.balance
          }}</span>
          <img src="@/assets/images/rcb.png" alt="" class="marginright40 rcb" />

          <span
            class="marginright10"
            style="cursor: pointer"
            @click="viewEarnest"
            >企业保证金:</span
          >
          <span style="color: #ff4141; margin-right: 50px"
            >￥{{ info && info.use_earnest }}</span
          >
          <el-tooltip
            class="item"
            effect="dark"
            content="退出登录"
            placement="bottom"
          >
            <div class="logout" @click="logout">
              <i
                class="el-icon-switch-button"
                style="font-size: 20px; color: #333"
              ></i>
            </div>
          </el-tooltip>
        </div>
      </div>
    </el-header>
    <el-container style="overflow: auto">
      <NaviBar :isCollapse="isCollapse"></NaviBar>
      <el-main class="layout__main">
        <!-- <page-header></page-header> -->
        <router-view
          v-if="hasPass || activeIndex == '/enterprise'"
        ></router-view>
        <notAuthentication
          v-if="!hasPass && activeIndex != '/enterprise'"
        ></notAuthentication>
      </el-main>
    </el-container>
    <posit ref="positRef"></posit>
    <balance ref="balanceRef"></balance>
  </el-container>
</template>
<script>
import PageHeader from "./PageHeader.vue";
import NaviBar from "./NaviBar";
import { getStorage, setStorage, clear, remove } from "@/storage";
import notAuthentication from "@/components/xypComponents/notAuthentication.vue";
import { TUILogin } from "@tencentcloud/tui-core";
import balance from "./components/balance.vue";
import posit from "./components/posit.vue";
export default {
  name: "LayoutContainer",
  components: {
    NaviBar,
    PageHeader,
    notAuthentication,
    posit,
    balance,
  },
  data() {
    return {
      isCollapse: false,
      toggleMenu: false,
      info: {},
      pass_at: getStorage("pass_at"),
    };
  },
  created() {
    this.GetDetail();
  },
  mounted() {
    this.$eventbus.$on("layoutGetDetail", (str) => {
      this.getData(str);
    });
  },
  beforeDestroy() {
    remove("router_path");
    this.$eventbus.$off("layoutGetDetail");
  },
  methods: {
    getData(str) {
      console.log(str);
      // this.GetDetail();
    },
    GetDetail() {
      this.$http.post("/company/company/index", {}).then((res) => {
        if (res.code == 1) {
          let info = res.data || {};
          this.info = info;
          this.pass_at = info.pass_at;
          setStorage("info", info);
          setStorage("name", info.name);
          setStorage("use_earnest", info.use_earnest);
          setStorage("balance", info.balance);
          setStorage("xy_code", info.xy_code);
          setStorage("pass_at", info.pass_at);
          setStorage("auth_status", info.auth_status);
          setStorage("apply_info", info.apply_info);
        }
      });
    },
    logout() {
      this.$confirm("请确认是否退出登录？", "提示", {
        beforeClose: (action, instance, done) => {
          if (action === "confirm") {
            TUILogin.logout().then(() => {
              localStorage.removeItem("tencent_token");
              localStorage.removeItem("tencent_accid");
            });
            clear(); // 删除token
            this.$router.push("/login");
            done();
          } else {
            done();
          }
        },
      }).catch((err) => {});
    },
    // 展开、收起
    toggleColl() {
      this.isCollapse = !this.isCollapse;
      this.toggleMenu = !this.toggleMenu;
      if (this.isCollapse) {
        this.isbigger = "J_bigger";
      } else {
        this.isbigger = "";
      }
    },
    viewEarnest() {
      let dom = this.$refs.positRef;
      dom.toggle(true);
      dom = null;
    },
    viewBalance() {
      let dom = this.$refs.balanceRef;
      dom.toggle(true);
      dom = null;
    },
  },
  computed: {
    hasPass() {
      // pass_at  有值代表认证通过
      return Boolean(this.pass_at);
    },
    activeIndex() {
      return this.$route.path;
    },
    account() {
      return getStorage("account");
    },
    nickname() {
      return getStorage("nickname");
    },
  },
  watch: {
    $route(to, from) {
      if (to.path != '/login') { 
        this.GetDetail();
      }
    },
  },
};
</script>

<style scoped lang="scss">
.layout__wrap {
  width: 100%;
  height: 100vh;
  background-color: #f5f5f5;
  .header__wrap {
    background-color: $theme;
    display: flex;
    align-items: center;
    justify-content: space-between;

    // background-image: linear-gradient(to right, $theme, #0bCFFF);
    .logo__wrap {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 200px;
      height: 100%;
      .logo {
        width: 100px;
      }
      .logoText {
        color: #fff;
        margin-left: 80px;
        font-size: 20px;
        font-weight: bold;
      }
      .J_menutoggle {
        color: #fff;
        margin-left: 20px;
      }
    }
    .avatar__wrap {
      flex: 1;
      height: 100%;
      background: #ffffff;
      border-radius: 30px 0px 0px 0px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-weight: 400;
      font-size: 18px;
      padding: 0px 60px 0px 30px;
      color: #333333;
      font-family: Microsoft YaHei;
      .rcb {
        width: 24px;
        height: 24px;
      }
      .marginright40 {
        margin-right: 40px;
      }
      .marginright10 {
        margin-right: 10px;
      }
      .avatar__wrap-left {
        display: flex;
        align-items: center;
      }
      .avatar__wrap-right {
        display: flex;
        align-items: center;
      }
      .hasBorder {
        border-radius: 14px;
        border: 1px solid #cccccc;
        padding: 4px 6px;
        font-size: 16px;
      }
      .userName {
        margin-right: 20px;
      }
      .exit {
        cursor: pointer;
        display: flex;
      }
    }
  }
  .layout__main {
    display: flex;
    flex-direction: column;
    padding: 0;
    .page-header__wrap {
      display: flex;
      justify-content: space-between;
      align-items: center;
      background-color: #ffffff;
      color: #595959;

      .title {
        height: 58px;
        line-height: 58px;
      }
    }

    & > div {
      flex: 1;
      min-height: 0;
      overflow: hidden;
    }
  }
}
::v-deep .el-header {
  padding: 0;
}
.logout {
  cursor: pointer;
  margin-left: 20px;
}
</style>
